import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm, getFormValues } from 'redux-form';
import PropTypes from 'prop-types'
import { required, numericality } from 'redux-form-validators';
import InputField from '../../../helpers/Fields/InputField';
import TextEditorField from '../../../helpers/Fields/TextEditorField';
import DateField from '../../../helpers/Fields/DateField';
import SwitchField from '../../../helpers/Fields/SwitchField';
import SelectField from '../../../helpers/Fields/SelectField';
import CheckboxField from '../../../helpers/Fields/CheckboxField';
import { Checkbox } from 'antd';
import { CirclePicker } from 'react-color';
import {toastr} from 'react-redux-toastr'

class FormSetting extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      hasPassword: props.initialValues.password,
      time_limit: props.initialValues.time_limit > 0,
      try_limit: props.initialValues.try_limit > 0,
    }
  }
  

  submit = (values) => {
    const {formatMessage} = this.context
    if(moment() > moment(values.active_to)){
      toastr.warning(formatMessage('msgWarningPublic'), formatMessage('msgWarningPublicMessage'));
      return;
    } 

    const {onSave} = this.props;
    const {hasPassword, time_limit, try_limit } = this.state;
    if(!hasPassword){
      values.password = '';
    }

    if(!time_limit) {
      values.time_limit = 0;
    }
    
    if(!try_limit) {
      values.try_limit = 0;
    }

    if(!values.answers_after_done){
      values.answers_after_done_type = 0;
    }

    onSave(values);
  } 

  render() {
    const {formatMessage} = this.context
    const { handleSubmit, history, rooms } = this.props;
    let {valuesForm } = this.props;

    if(!valuesForm){
      valuesForm = {};
    }
    
    return (
      <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='title'
          label={formatMessage('txtCaptionQuizTitle')}
          component={InputField}
          validate={[required()]}
        />
        <Field 
          name='description'
          label={formatMessage('txtCaptionQuizDescription')}
          component={TextEditorField}
        />
        
        <Field 
          name='quiz_type'
          label={formatMessage('txtCaptionQuizType')}
          component={SelectField}
          options={[
            {value: 1, title: 'Practice Quizz'},
          ]}
          validate={[required()]}
        />
        <Field 
          name='room'
          label={formatMessage('txtCaptionQuizClassroom')}
          component={SelectField}
          options={rooms.map(item => ({value: item.id, title: item.title}))}
          validate={[required()]}
        />
        
        <Field 
          name='shuffle_answers'
          label={formatMessage('txtCaptionQuizShuffleAnswer')}
          component={CheckboxField}
          type="int"
        />

        <div className="form__form-group" style={{display: 'flex'}}>
          <Checkbox checked={this.state.time_limit} onChange={() => {
            this.setState({time_limit: !this.state.time_limit});
          }}>{formatMessage('txtCaptionCheckboxTimeLimit')}</Checkbox>
            {this.state.time_limit && <div style={{display: 'flex', marginLeft: 10}}>
              <Field 
                name='time_limit'
                component={InputField}
                handleChange={(event, input) => {
                  if(!isNaN(parseFloat(event.target.value))){
                    input.onChange(parseFloat(event.target.value))
                  } else {
                    input.onChange(event)
                  }
                }}
                validate={[required(), numericality({'>': 0, int: true, '<=': 1440})]}
                style={{margin: '0'}}
              />
              <label style={{marginLeft: 10}}>{formatMessage('txtCaptionTimeLimitMinutes')}</label>
            </div>}
            
        </div>

        <div className="form__form-group">
          <Checkbox checked={this.state.try_limit} onChange={() => {
            if(!this.state.try_limit){
              this.props.change('try_limit', 1);
              this.props.change('try_rules', 1);
            }
            this.setState({try_limit: !this.state.try_limit});
          }}>{formatMessage('txtCaptionAllowMultipleAttempts')}</Checkbox>
            {this.state.try_limit && <div style={{marginLeft: 40}}>
              <Field
                name='try_limit'
                label={formatMessage('txtCaptionAttempts')}
                component={InputField}
                handleChange={(event, input) => {
                  if(!isNaN(parseFloat(event.target.value))){
                    input.onChange(parseFloat(event.target.value))
                  } else {
                    input.onChange(event)
                  }
                }}
                validate={[required(), numericality({'>': 0, int: true })]}
                style={{margin: '0'}}
              />
              <Field 
                name='try_rules'
                label={formatMessage('txtCaptionQuizzScoreKeep')}
                component={SelectField}
                options={[
                  {value: 1, title: formatMessage('txtCaptionHighestScore')},
                  {value: 2, title: formatMessage('txtCaptionLatestScore')},
                  {value: 3, title: formatMessage('txtCaptionAverageScore')},
                ]}
                validate={[required()]}
              />
            </div>}
            
        </div>

        <Field 
          name='answers_after_done'
          label={formatMessage('txtMessageLetStudentSeeFeedbade')}
          component={CheckboxField}
          type="int"
        />

        {valuesForm.answers_after_done ? <div style={{marginLeft: 40}}>
          <Field 
            name='answers_after_done_type'
            label={formatMessage('txtMessageLetStudentSeeCorrectAnswer')}
            component={CheckboxField}
            type="int"
          />
        </div> : null}
       
        <div className="form__form-group" style={{marginBottom: !this.state.hasPassword ? '20px' : '5px',}}>
          <Checkbox checked={this.state.hasPassword} onChange={() => {
            this.setState({hasPassword: !this.state.hasPassword});
          }}>{formatMessage('txtCaptionQuezRequrePassword')}</Checkbox>
        </div>


        {this.state.hasPassword ? <Field 
          name='password'
          component={InputField}
          validate={[required()]}
        /> : null}

        <Field 
          name='active_from'
          label={formatMessage('txtCaptionAvailableFrom')}
          component={DateField}
          onHandleChange={(value, input) => {
            input.onChange(value);
            if(value > moment(valuesForm.active_to)){
              this.props.change('active_to', value)
            }
          }}
          validate={[required()]}
          inputProps={{
            format: "DD MMM YYYY",
            disabledDate: (current) => {
              return (current && current <= moment().endOf('day').subtract(1, 'day'));
            }
          }}
          inputPropsTime={{
            disabledHours: () => {
              const hours = new Date().getHours();
              const disabledH = [];
              for(const [index] of Array(hours).entries()){
                disabledH.push(index)
              }
              return disabledH
            },
            disabledMinutes: () => {
              const minutes = new Date().getMinutes();
              const disabledM = [];
              for(const [index] of Array(minutes).entries()){
                disabledM.push(index)
              }
              return disabledM
            },
            disabledSeconds: () => {
              const sec = new Date().getSeconds();
              const disabledS = [];
              for(const [index] of Array(sec).entries()){
                disabledS.push(index)
              }
              return disabledS
            }
          }}
        />
        <Field 
          name='active_to'
          label={formatMessage('txtCaptionAvailableUntil')}
          component={DateField}
          validate={[required()]}
          inputPropsTime={{
            disabledHours: () => {
              
              if(moment(valuesForm.active_to).format('MM/DD/YY') == moment(valuesForm.active_from).format('MM/DD/YY')) {
                const hours = moment(valuesForm.active_from).toDate().getHours();
                const disabledH = [];
                for(const [index] of Array(hours).entries()){
                  disabledH.push(index)
                }
                return disabledH
              }
              return [];
              
            },
            disabledMinutes: () => {
              if(moment(valuesForm.active_to).format('MM/DD/YY') == moment(valuesForm.active_from).format('MM/DD/YY')) {
                const minutes = moment(valuesForm.active_from).toDate().getMinutes();
                const disabledM = [];
                for(const [index] of Array(minutes).entries()){
                  disabledM.push(index)
                }
                return disabledM
              }
              return [];
            },
            disabledSeconds: () => {
              if(moment(valuesForm.active_to).format('MM/DD/YY') == moment(valuesForm.active_from).format('MM/DD/YY')) {
                const sec = moment(valuesForm.active_from).toDate().getSeconds();
                const disabledS = [];
                for(const [index] of Array(sec).entries()){
                  disabledS.push(index)
                }
                return disabledS;
              }
              return [];
            }
          }}
          inputProps={{
            format: "DD MMM YYYY",
            disabledDate: (current) => (current && current < moment(valuesForm.active_from))
          }}
        />
        <Field 
          name='active'
          label={formatMessage('txtCaptionPublicationStatus')}
          component={SwitchField}
          trueTitle={formatMessage('txtCaptionPublished')}
          falseTitle={formatMessage('txtCaptionUnpublished')}
          handleClick={(value, input) => {
            if(value){
              if((moment() > moment(valuesForm.active_to)) ){
                toastr.warning(formatMessage('msgWarningPublic'), formatMessage('msgWarningPublicMessage'))
              } 
            }
            input.onChange(value);
          }}
        />
        <div className="form__form-group">
          <label>{formatMessage('txtCaptionQuizColor')}</label>
          <CirclePicker
            color={ valuesForm.color }
            onChangeComplete={(color) => {
              this.props.change('color', color.hex)
            }}
            colors={[
              "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#ddd"
            ]}
          />
        </div>

        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between', flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            history.push('/quizs');
          }}>{formatMessage('btnQuizCancel')}</button>
            <button className="btn btn-primary" type="submit">{formatMessage('btnQuizUpdate')}</button>
        </div>
      </form>
    );
  }
}

FormSetting = reduxForm({
  form: 'form_quiz',
  enableReinitialize: true,
})(FormSetting);

const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_quiz')(state),
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(FormSetting);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quiz/components/FormSetting/index.jsx